import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { selectProcessById } from 'state/ProjectsList/include/processesSlice';

interface ProjectProcessProps {
  process: string;
}

const ProjectProcess: FC<ProjectProcessProps> = ({ process }) => {
  const processData = useSelector((state: RootState) =>
    selectProcessById(state, process)
  );

  if (!processData) {
    return null;
  }
  return <>{processData.name}</>;
};

export default ProjectProcess;
